import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

/**
 * Gallery box masonry
 */
var oldGalleryGrid = document.querySelectorAll('.js-masonry-gallery');
if (oldGalleryGrid.length > 0) {
  oldGalleryGrid.forEach(function (grid) {
    imagesLoaded(grid, function () {
      new Masonry(grid, {
        itemSelector: '.js-masonry-gallery-item',
        columnWidth: 1,
        percentPosition: true,
        horizontalOrder: true,
        // gutter: 6,
      });
    });
  });
}

/**
 * Gallery masonry.
 * Initialize only on desktops
 */
const breakpointMD = window.matchMedia('(min-width:1024px)');
const galleryGrid = document.querySelector('.js-project-gallery-masonry');

let galleryMsnry;

const breakpointChecker = function () {
  if (breakpointMD.matches === true) {
    if (galleryMsnry !== undefined) {
      // masonry exist, so just re-layout masonry grid items
      imagesLoaded(galleryGrid, function () {
        galleryMsnry.layout();
      });
    } else {
      // initialize new masonry
      return initMasonry();
    }
    // return;
  } else if (breakpointMD.matches === false) {
    // Masonry not needed, destroy
    // if (galleryMsnry !== undefined) {
    //   galleryMsnry.destroy();
    // }
  }
};

const initMasonry = function () {
  imagesLoaded(galleryGrid, function () {
    galleryMsnry = new Masonry(galleryGrid, {
      itemSelector: '.js-project-gallery-masonry-item',
      columnWidth: '.js-project-gallery-masonry-grid-sizer',
      percentPosition: true,
      gutter: '.js-project-gallery-masonry-gutter-sizer',
    });
  });
};

if (galleryGrid) {
  // keep an eye on viewport size changes
  breakpointMD.addEventListener('change', breakpointChecker);

  // kickstart
  breakpointChecker();
}
